module.exports = "/packs/images/homepage/facilities/leisure_desktop~07a55eaa5edc669a2eb8e95964168477.jpg";